import React, { useState } from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

const AtlasV2Sales1P3PSplineChart = () => {
  const [fieldName, setFieldName] = useState('retailSales');

  return (
    <AtlasV2ComparableSplineChart
      fieldName={fieldName}
      indexName="sales"
      singleDropdownProps={{
        defaultLabel: 'Retail Sales',
        options: [
          {
            label: 'Retail Sales',
            id: 'retailSales'
          },
          {
            label: '1P Retail Sales',
            id: 'onePSales'
          },
          {
            label: '3P Retail Sales',
            id: 'threePSales'
          }
        ],
        selectedId: fieldName,
        onChange: (option) => setFieldName(option.id)
      }}
    />
  );
};

export default AtlasV2Sales1P3PSplineChart;
